import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    background: "#141414",
    justifyContent: "space-between",
    padding: `${theme.spacing.space8}px ${theme.spacing.space16}px`,
    position: "fixed",
    width: "-webkit-fill-available",
    bottom: 0,
    left: 0,
    alignItems: "center",
    zIndex: theme.zIndex.appBar + 1,
    transition: "bottom 1s ease-in-out",
    display: "flex",
    "&.hide": {
      bottom: "-60px",
    },
  },
  icon: {
    height: 24,
    animation: "$fadeIn 1s ease-in-out",
  },
  itemContent: {
    height: 30,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space20,
  },
  buttonItem: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space4,
    cursor: "pointer",
  },
  item: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space8,
    cursor: "pointer",
    opacity: 0,
  },
  showMessage: {
    animation: "$fadeInOut 4s 1s ease-in-out",
  },
  holdLabel: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space4,
    borderRadius: 14,
    border: "1px solid #FFF",
    padding: "2px 4px",
  },
  "@keyframes fadeInOut": {
    "0%": {
      opacity: 0,
    },
    "20%": {
      opacity: 1,
    },
    "80%": {
      opacity: 1,
    },
    "100%": {
      opacity: 0,
    },
  },
  "@keyframes fadeIn": {
    "0%": {
      opacity: 0,
    },
    "100%": {
      opacity: 1,
    },
  },
}));
